import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useContent } from "../ContentContext";
import SEO from "./SEO";

const Legal = ({ title, seoTitle, seoDescription, path, children }) => (
  <div className="min-h-screen py-28 px-6 md:px-12" style={{ background: "var(--bone)" }}>
    <SEO title={seoTitle || title} description={seoDescription} path={path} />
    <div className="max-w-3xl mx-auto">
      <Link to="/" data-testid="legal-back" className="inline-flex items-center gap-2 mb-8 text-sm font-semibold" style={{ color: "var(--brass)" }}>
        <ArrowLeft size={16} /> Back to home
      </Link>
      <h1 className="font-display font-extrabold uppercase tracking-tight text-4xl sm:text-5xl" style={{ color: "var(--pine)" }}>{title}</h1>
      <div className="mt-8 space-y-4 leading-relaxed" style={{ color: "#3a3a3a" }}>{children}</div>
    </div>
  </div>
);

export const Privacy = () => {
  const { company } = useContent();
  return (
    <Legal
      title="Privacy Policy"
      seoTitle="Privacy Policy"
      seoDescription="Learn how Top of the Line Tree Services LLC collects, uses and protects the personal information you share when requesting an estimate or appointment."
      path="/privacy"
    >
      <p>{company.name} respects your privacy. This page explains how we handle information you provide through our website.</p>
      <p><b>Information we collect.</b> When you submit an estimate or appointment request we collect your name, phone, email, address, project details and any photos you choose to upload.</p>
      <p><b>How we use it.</b> Your information is used solely to respond to your request, provide estimates and schedule services. We do not sell your data.</p>
      <p><b>Contact.</b> For privacy questions, call us at {company.phone}.</p>
    </Legal>
  );
};

export const Terms = () => {
  const { company } = useContent();
  return (
    <Legal
      title="Terms & Conditions"
      seoTitle="Terms & Conditions"
      seoDescription="Terms of use for the Top of the Line Tree Services LLC website — estimate requests, appointment policy and service disclaimers."
      path="/terms"
    >
      <p>By using this website and submitting a request you agree to the following terms.</p>
      <p><b>Requests are not confirmed appointments.</b> Selecting a date on our calendar submits a request only. An appointment is confirmed only after our team contacts and approves it.</p>
      <p><b>Estimates.</b> Estimates are free and provided after we review your request and, when needed, visit your property.</p>
      <p><b>Contact.</b> Questions? Call {company.phone}.</p>
    </Legal>
  );
};
